import { defineMessages } from 'react-intl';

export default defineMessages({
	description: {
		id: 'components.walletPayment.barcodeScanner.description',
		defaultMessage:
			'لطفا بارکد مشتری را داخل کادر سفید زیر قرار داده و اسکن کنید.',
	},
	manualButton: {
		id: 'components.walletPayment.barcodeScanner.manualButton',
		defaultMessage: 'وارد کردن دستی شماره بارکد',
	},
	exitButton: {
		id: 'components.walletPayment.barcodeScanner.exitButton',
		defaultMessage: 'انصراف',
	},
	modalTitle: {
		id: 'components.walletPayment.barcodeScanner.modalTitle',
		defaultMessage: 'انصراف از پرداخت مشتری',
	},
	insufficient: {
		id: 'components.walletPayment.barcodeScanner.insufficient',
		defaultMessage: 'موجودی کیف پول مشتری کافی نیست!',
	},
});
